// Google SERP fit helpers (Iter-457). Limits match the admin length check.
export const SERP_TITLE_MAX = 60;
export const SERP_DESC_MAX = 160;
const BRAND = " | CarSavr";

// First candidate that fits with the brand suffix; else first that fits without it.
export function fitTitle(candidates) {
  const c = candidates.filter(Boolean);
  const branded = c.find((t) => (t + BRAND).length <= SERP_TITLE_MAX);
  if (branded) return { title: branded, brand: true };
  return { title: c.find((t) => t.length <= SERP_TITLE_MAX) || c[c.length - 1], brand: false };
}

// Keep whole leading sentences when they fill ≥120 chars; otherwise word-cut near the limit.
export function clampDescription(text, limit = SERP_DESC_MAX) {
  const t = (text || "").trim();
  if (t.length <= limit) return t;
  let out = "";
  for (const s of t.split(/(?<=[.!?])\s+(?=[A-Z0-9$])/)) {
    const cand = `${out} ${s}`.trim();
    if (cand.length > limit) break;
    out = cand;
  }
  if (out.length >= 120) return out;
  return t.slice(0, limit - 1).replace(/\s+\S*$/, "").replace(/[\s,;:—–-]+$/, "") + "…";
}
